import * as THREE from 'three'

// FOUNDATION §2 — the entire world is neutral except for cyan.
export const GROUND = new THREE.Color('#F2F5F7')
export const WHITE = new THREE.Color('#FFFFFF')
export const SURFACE1 = new THREE.Color('#E4E9ED')
export const SURFACE2 = new THREE.Color('#CBD3DA')
export const SURFACE3 = new THREE.Color('#A7B2BB')
export const INK = new THREE.Color('#171C20')
export const INK_MID = new THREE.Color('#5A656E')
export const INK_FAR = new THREE.Color('#BFC8CF')
export const CYAN_CORE = new THREE.Color('#0091AE')
export const CYAN = new THREE.Color('#00B8D4')
export const CYAN_LIGHT = new THREE.Color('#7FE3F0')
export const CYAN_WASH = new THREE.Color('#E2F6FA')
// randommonkey.io logo ink dots — sparse highlights in the animations;
// cyan remains the language, these are the accents
export const MAGENTA = new THREE.Color('#D6136B')
export const YELLOW = new THREE.Color('#EFC500')

export const glsl = (c: THREE.Color) => `vec3(${c.r.toFixed(4)}, ${c.g.toFixed(4)}, ${c.b.toFixed(4)})`
